import SettingAccountPage from "./SettingAccountContainer";

export default SettingAccountPage;
